import { render, staticRenderFns } from "./ClassScheduleCard.vue?vue&type=template&id=ae1563d4&"
import script from "./ClassScheduleCard.vue?vue&type=script&lang=js&"
export * from "./ClassScheduleCard.vue?vue&type=script&lang=js&"
import style0 from "./ClassScheduleCard.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports